var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useState } from 'react';
import { api, apiResolve } from '@sierralabs/core-ui';
export function useGetSiteTraceBoard() {
    const [state, setState] = useState({ isLoading: false });
    const getBoard = useCallback((id, params) => __awaiter(this, void 0, void 0, function* () {
        const request = api.post(`components/plugins/site-trace-board/${id}`, params);
        const { data, error } = yield apiResolve(request);
        setState(state => (Object.assign(Object.assign({}, state), { error })));
        return data;
    }), []);
    const setBoardLoading = useCallback((isLoading) => {
        setState(state => (Object.assign(Object.assign({}, state), { isLoading })));
    }, []);
    return Object.assign(Object.assign({}, state), { getBoard, setBoardLoading });
}
//# sourceMappingURL=useGetSiteTraceBoard.js.map